import { NgModule } from "@angular/core";
import { WorkflowFormModule } from "../form/workflow-form.module";
import { ProjectWorkflowListModule } from "./list/project-workflow-list.module";
import { ProjectWorkflowRoutingModule } from "./project-workflow.routing";

@NgModule({
    imports: [ProjectWorkflowRoutingModule, ProjectWorkflowListModule, WorkflowFormModule],
})
export class ProjectWorkflowModule {}
